import { render } from "./wechat.warn.vue?vue&type=template&id=3738259e&scoped=true"
import script from "./wechat.warn.vue?vue&type=script&lang=js"
export * from "./wechat.warn.vue?vue&type=script&lang=js"

import "./wechat.warn.vue?vue&type=style&index=0&id=3738259e&scoped=true&lang=css"

import exportComponent from "E:\\work\\download-page\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3738259e"]])

export default __exports__